{
  "name": "app-stdag",
  "version": "1.31.15",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o --proxy-config proxy.conf.json",
    "build": "ng build",
    "test": "ng test",
    "lint": "eslint . --ext .ts",
    "e2e": "ng e2e"
  },
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "angular-datatables": "^19.0.0",
    "angular-google-charts": "^16.1.0",
    "angular-notifier": "^14.0.0",
    "core-js": "^3.34.1",
    "crypto-js": "^4.2.0",
    "datatables.net": "^1.13.10",
    "datatables.net-dt": "^2.0.3",
    "datatables.net-responsive": "^2.2.3",
    "datatables.net-responsive-dt": "^2.2.3",
    "datatables.net-select": "^1.3.1",
    "datatables.net-select-dt": "^1.3.1",
    "jquery": "^3.7.1",
    "ng-multiselect-dropdown": "^0.2.3",
    "ng2-rut": "^0.2.3",
    "ng2-tooltip-directive": "^2.1.9",
    "querystring-es3": "^0.2.1",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.2",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@angular/language-service": "^19.2.14",
    "@types/datatables.net": "^1.12.3",
    "@types/datatables.net-select": "^1.2.5",
    "@types/jquery": "^3.5.32",
    "@types/node": "^20.11.30",
    "eslint": "^8.57.0",
    "eslint-plugin-import": "^2.29.1",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^1.7.0",
    "protractor": "~7.0.0",
    "sass": "^1.32.13",
    "ts-node": "^10.9.2",
    "typescript": "5.8.3"
  }
}
